export default __webpack_public_path__ + "static/media/uranium_pellet.1a3989e9.png";